import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moduleIcon from "../assets/module.png";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";
import { useTelemedicine } from "../hooks/useTelemedicine";

const TeleMedicine = ({
  isTelemedicine,
  telemedModalities,
  telemedCaregiverAccess,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const telemedicineData = useTelemedicine();

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <label className="left-align">
      {isTelemedicine && <>{t(`telemedicineYes`)}</>}{" "}
      {!isTelemedicine && <>{t(`telemedicineNo`)}</>}
      {isTelemedicine == true &&
        telemedModalities !== null &&
        telemedModalities !== "" && (
          <div className="ml-3">
            ({telemedModalities})
            <span onClick={handleClick}>
              {" "}
              <img
                src={moduleIcon}
                alt="Provider Search - Telemedmodalities Image"
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
        )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="popup-menu"
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose} className="popup-item">
          <p style={{ color: "#007839" }}>
            <>{t(`viewModality`)}</>&nbsp;
            <a href={telemedicineData} style={{ color: "#007839" }}>
              <b>{t(`here`)}</b>
            </a>
          </p>
        </MenuItem>
      </Menu>
      <div className="ml-3">
        {isTelemedicine === true &&
          telemedCaregiverAccess !== null &&
          telemedCaregiverAccess !== "" &&
          telemedCaregiverAccess !== undefined &&
          telemedCaregiverAccess && <>{t(`caregiverYes`)}</>}

        {isTelemedicine === true &&
          telemedCaregiverAccess !== null &&
          telemedCaregiverAccess !== "" &&
          telemedCaregiverAccess !== undefined &&
          !telemedCaregiverAccess && <>{t(`caregiverNo`)}</>}
      </div>
    </label>
  );
};

TeleMedicine.propTypes = {
  isTelemedicine: PropTypes.boolean,
  telemedModalities: PropTypes.string,
  telemedCaregiverAccess: PropTypes.string,
};

export default TeleMedicine;
